import { render, staticRenderFns } from "./TransferSummaryRow.vue?vue&type=template&id=255adade&scoped=true"
import script from "./TransferSummaryRow.vue?vue&type=script&lang=js"
export * from "./TransferSummaryRow.vue?vue&type=script&lang=js"
import style0 from "./TransferSummaryRow.vue?vue&type=style&index=0&id=255adade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255adade",
  null
  
)

export default component.exports